import { schema } from 'normalizr'

const restaurantCategory = new schema.Entity('restaurantCategories')

export default restaurantCategory
